import moment from 'moment';
import {TransactionStatus} from '../types';

export const TRANSACTION_COUNT = 10;

export enum Filter {
    Outgoing = 'Outgoing',
    Incoming = 'Incoming',
    Pending = 'Pending',
}

export const ALL_CONFIG = {
    start: moment('01-01-2020', 'DD-MM-YYYY')
        .startOf('month')
        .format('DD-MM-YYYY'),
    end: moment().endOf('month').format('DD-MM-YYYY'),
    page: 0,
    size: TRANSACTION_COUNT,
};

export const MONTH_CONFIG = {
    start: moment().subtract(1, 'month').startOf('month').format('DD-MM-YYYY'),
    end: moment().endOf('month').format('DD-MM-YYYY'),
    page: 0,
    size: 1000,
  };

export const FILTERS_CONFIG = {
    [Filter.Incoming]: { type: 'IN' },
    [Filter.Outgoing]: { type: 'OUT' },
    [Filter.Pending]: { status: TransactionStatus.Pending },
};
